require('./lbaConfirmButton.scss');


const $inject = [];
const lbaConfirmButton = function () {
  return {
    restrict: 'A',
    scope:{
      settings: '<'
    },
    bindToController: true,
    controller: 'lbaConfirmButtonCtrl',
    controllerAs: 'vm',
    template: require('./lbaConfirmButton.html')
  }
};

lbaConfirmButton.$inject = $inject;

export default lbaConfirmButton;



// WEBPACK FOOTER //
// ./src/components/lbaConfirmButton/lbaConfirmButtonDir.js